import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import notify from 'devextreme/ui/notify';
import isEmpty from 'lodash-es/isEmpty';
import { utc } from 'moment';
import { Consumer, Note } from '../../../../shared/sdk';
import { DlgAttendanceNotesGridComponent } from '../../dialogs/dlg-attendance-notes-grid/dlg-attendance-notes-grid.component';

@Component({
  selector: 'app-consumer-notes',
  templateUrl: './consumer-notes.component.html',
  styleUrls: ['./consumer-notes.component.scss'],
})
export class ConsumerNotesComponent implements OnInit {
  @Input() model: Consumer;
  @Input() wrap = true;

  constructor(private dialog: MatDialog) {}

  ngOnInit() {}

  info(note: Note) {
    const info = note
      ? [
          [note.infoBy ? `by ${note.infoBy}` : '', note.infoDate ? `on ${utc(note.infoDate).format('YYYY/MM/DD')}` : '']
            .filter(chnk => !isEmpty(chnk))
            .join(' '),
          note.followUpDate ? `Follow up on ${utc(note.followUpDate).format('YYYY/MM/DD')}` : '',
        ]
          .filter(chnk => !isEmpty(chnk))
          .join(', ')
      : '';

    return !isEmpty(info) ? `(${info})` : '';
  }

  async expand_onClick() {
    this.dialog
      .open(DlgAttendanceNotesGridComponent, {
        // width: '250px',
        height: '600px',
        hasBackdrop: true,
        data: { model: this.model },
      })
      .afterClosed()
      .toPromise()
      .catch(err => notify(err.message || err, 'error', 5000));
  }
}
